module.exports = __webpack_public_path__ + "static/media/libros_y_chips.1816204f.png";